import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import * as Styles from './Lead.module.css'

const LeadCard = ({
  companyLogo,
  data: {
    companyName = '',
    leadName = '',
    industryCategory = '',
    numberOfEmployees = '',
    leadScore = 18,
    className,
  },
}) => {
  return (
    <div className="bg-white shadow-gray-300-7xl rounded-lg w-full flex flex-col">
      <div className="w-full  flex items-center justify-start p-12 pb-6 gap-2">
        <div className={Styles.leadImage}>
          <GatsbyImage
            objectFit="cover"
            alt={companyName}
            image={getImage(companyLogo)}
          />
        </div>

        <div>
          <div className={Styles.companyName}>{companyName}</div>
          <div>{leadName}</div>
        </div>
      </div>
      <hr className="m-0 border-gray-100" />
      <div className="p-12 pt-6 space-y-6">
        <div className="space-y-1">
          <div className="text-xs font-medium tracking-wide text-gray-400 uppercase">
            Email
          </div>
          <div className="lowercase">
            {leadName.split(' ')[0]}.{leadName.split(' ')[1]}@{companyName}.com
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div className="space-y-2">
            <div className="text-xs font-medium tracking-wide text-gray-400 uppercase">
              Role
            </div>
            <div>Some Role</div>
          </div>

          <div className="space-y-2">
            <div className="text-xs font-medium tracking-wide text-gray-400 uppercase">
              Location
            </div>
            <div>Round Rock, Texas, US</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div className="space-y-2">
            <div className="text-xs font-medium tracking-wide text-gray-400 uppercase">
              Industry Category
            </div>
            <div>{industryCategory}</div>
          </div>

          <div className="space-y-2">
            <div className="text-xs font-medium tracking-wide text-gray-400 uppercase">
              Employees
            </div>
            <div>{numberOfEmployees}</div>
          </div>

          <div className="space-y-2 col-span-2">
            <div className="text-xs font-medium tracking-wide text-gray-400 uppercase">
              Tags
            </div>
            <div className="flex gap-2">
              <div className="bg-green-100 text-green-600 text-xs py-1 px-2 font-medium tracking-wide uppercase rounded-lg">
                Paid
              </div>
              <div className="bg-blue-100 text-blue-600 text-xs py-1 px-2 font-medium tracking-wide uppercase rounded-lg">
                Facebook Ads
              </div>
              <div className="bg-orange-100 text-orange-600 text-xs py-1 px-2 font-medium tracking-wide uppercase rounded-lg">
                Engaged
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeadCard
